import { Selection } from '../models/filterbar.model';

export const DEFAULT_SORTING: Selection['sorting'] = { field: 'id', direction: 'desc' };

/** Maximum number of grouping levels a user can stack (mirrors the backend clamp; default 3). */
export const MAX_GROUPING_DEPTH = 3;

/** The units a date field groups on, each one the suffix of a grouping attribute (`start_date.year`). */
export const DATE_GROUPING_UNITS = ['year', 'month', 'day'] as const;
